import $ from 'jquery';

export default class Newsletter {
  constructor(el) {
    this.el = el;
    this.$form = $('#contact_form', this.el);
    this.$submit = $('.submit', this.el);
    this.$newsletterWrap = $('.newsletter-wrap', this.el);
    this.processing = false;

    this.$submit.on('click', e => {
      e.preventDefault();
      this._submitNewsletter(e);
    });
  }

  _submitNewsletter() {
    if (this.processing) { return; }

    this.processing = true;
    this.$newsletterWrap.addClass('newsletter-submit-loading');

    $.ajax({
      type: 'POST',
      url: '/contact#contact_form',
      data: this.$form.serialize(),
      success: () => {
        this.processing = false;
        this.$newsletterWrap.removeClass('newsletter-submit-loading');
        this.$newsletterWrap.addClass('newsletter-submitted');
      },
      error: this.handleErrors.bind(this)
    });
  }

  handleErrors(response) {
    // 429 means we've hit the reCaptcha - must submit by default
    if (response.status === 429) {
      this.$form.submit();
    } else {
      const error = response.responseText;

      this.$form.append(`<p class="error-message">${error.description}</p>`);
      this.processing = false;
      this.$newsletterWrap.removeClass('newsletter-submit-loading');
    }
  }

  unload() {
    this.$submit.off('click');
  }
}
